import React from "react";
import { Col, Row } from "antd";

function DataHeader(props) {
    return (
        <Row style={{ display: "flex", alignItems: "center" }}>
            <Col span={12}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div>
                        <h2 className={"dados-header"}>Certificações</h2>
                        <span className={"dados-header-subtitle"}>Procure por um usuário para visualizar suas certificações.</span>
                    </div>
                </div>
            </Col>
            <Col span={12}>
                
            </Col>
        </Row>
    )
}

export default DataHeader;
